import { useLocation } from 'react-router-dom';
// import { STATES } from './states_IN.js';
import dayjs from 'dayjs';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography } from '@mui/material';
import jwtDecode from 'jwt-decode';

const convertAppointmentDateTimeToItsLocationTime = (dateTime, location) => {};

export const getFileExtensionAndMimeTypeFromUrl = url => {
  // Extract the extension
  let extension = url?.split('.').pop().split(/\#|\?/)[0];

  extension = extension?.toLowerCase();

  // Define known extensions and MIME types
  let fileTypes = {
    csv: 'text/csv',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    txt: 'text/plain',
    dcm: 'application/dicom',
    jpg: 'application/jpg',
    jpeg: 'application/jpeg',
    png: 'application/png',
    zip: 'application/zip',
  };

  // Get the MIME type from the extension
  let mimeType = fileTypes[extension];

  // If the extension is not recognized, return an error
  if (!mimeType) {
    // throw new Error('Unknown file type');
  }

  // Return the extension and MIME type
  return {
    extension,
    mimeType,
  };
};

export const handleMimeType = url => {
  if (!url) {
    return;
  }
  const getFileMeta = getFileExtensionAndMimeTypeFromUrl(url);
  return getFileMeta?.mimeType;
};

export const getDateOnly = d => {
  return dayjs(d)?.format(`MM/DD/YYYY`);
  // return dayjs(d)?.format(`DD/MM/YYYY`);
};

export const getTimeOnly = d => {
  return dayjs(d)?.format(`HH:mm`);
};

export const getDateTime = d => {
  return `${getDateOnly(d)} ${getTimeOnly(d)}`;
};

function AddZero(num) {
  return num >= 0 && num < 10 ? '0' + num : num + '';
}

export const useQuery = () => new URLSearchParams(useLocation().search);

export const Capitalize = word => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const sortArrayOfObjects = property => {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

export const nestedSortOfObjects =
  (prop1, prop2 = null, direction = 'asc') =>
  (e1, e2) => {
    const a = prop2 ? e1[prop1][prop2] : e1[prop1],
      b = prop2 ? e2[prop1][prop2] : e2[prop1],
      sortOrder = direction === 'asc' ? 1 : -1;
    return a < b ? -sortOrder : a > b ? sortOrder : 0;
  };

export const getZipCodes = (code, country = 'US') => {
  const STATES = require(`./states_${country}.js`).default;
  let zipCodes = [];
  let uniqueCodes = {};
  let cities = STATES[code]?.cities;
  if (cities) {
    Object.keys(cities).forEach(m => {
      cities[m].forEach(c => {
        zipCodes.push({ code: c, display: String(c) });
      });
    });
    return zipCodes.sort(sortArrayOfObjects('code')).filter(option => {
      if (!uniqueCodes[option.code]) {
        uniqueCodes[option.code] = true;
        return true;
      }
      return false;
    });
  } else return [];
};

export const prettifySSN = ssn => {
  if (!ssn) return '';
  let ssnCopy = Array.from(ssn);
  return ssnCopy?.length <= 4
    ? `*****${ssn}`
    : `*****${ssnCopy.slice(5, 9).join('')}`;
  // : `${ssnCopy.slice(0, 3).join('')}-${ssnCopy.slice(3, 5).join('')}-${ssnCopy
  //     .slice(5, 9)
  //     .join('')}`;
};

export const prettifyAADHAAR = aadhaar => {
  if (!aadhaar) return '';
  let aadhaarCopy = Array.from(aadhaar);
  return `${aadhaarCopy.slice(0, 4).join('')}-${aadhaarCopy
    .slice(4, 8)
    .join('')}-${aadhaarCopy.slice(8, 12).join('')}`;
};

export const prettifyPhone = phone => {
  if (!phone) return '';
  let phoneCopy = Array.from(phone);
  if (phone?.length > 10) {
    const lastTenDigitStarts = phone?.length - 10;
    return `(${phoneCopy
      .slice(lastTenDigitStarts, lastTenDigitStarts + 3)
      .join('')}) ${phoneCopy
      .slice(lastTenDigitStarts + 3, lastTenDigitStarts + 6)
      .join('')}-${phoneCopy
      .slice(lastTenDigitStarts + 6, lastTenDigitStarts + 10)
      .join('')}`;
  } else {
    return `(${phoneCopy.slice(0, 3).join('')}) ${phoneCopy
      .slice(3, 6)
      .join('')}-${phoneCopy.slice(6, 10).join('')}`;
  }
};

export const prettifyPhoneIndianFormat = phone => {
  if (!phone) return '';
  let phoneCopy = Array.from(phone);
  return `${phoneCopy.slice(0, 4).join('')}-${phoneCopy.slice(4).join('')}`;
};

export const components = {
  loading: params => {
    if (params?.value !== undefined) {
      return params.value;
    } else if (
      params?.node?.data?.avatar == 'not_found' ||
      params?.data?.id == 'No Data Found'
    ) {
      return <></>;
    } else {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            marginTop: 1,
          }}
        >
          <CircularProgress
            sx={{ display: 'flex' }}
            style={{ marginRight: 10 }}
            size={20}
          />

          <Typography> Loading...</Typography>
        </Box>
      );
    }
  },
};

export const setHTML = html => {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export function decodeHtmlEntities(encodedString) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = encodedString;
  return textarea.value;
}

export const removeSpecialCharsFromPhone = phone => {
  if (!phone) return '';
  if (!Array.isArray(phone)) {
    phone = phone.split(' ');
    phone.shift();
  }
  return phone
    .join('')
    .replace(/[^\w\s]/gi, '')
    .replaceAll(' ', '');
};

export const getUserIdFromToken = () => {
  let token = localStorage.getItem('jwtToken');
  if (token) {
    token = jwtDecode(token);
    return token?.user_id || '';
  } else return '';
};

export const getTenantFromToken = () => {
  let token = localStorage.getItem('jwtToken');
  if (token) {
    token = jwtDecode(token);
    return token?.firebase?.tenant || '';
  } else return '';
};

export const getDataFromToken = () => {
  let token = localStorage.getItem('jwtToken');
  if (token) {
    token = jwtDecode(token);
    return token || '';
  } else return '';
};

export const camelCaseToSentence = text => {
  const result = text.replace(/([A-Z])/g, ' $1').toLowerCase();
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const capitalizeFirstLetter = string => {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const addEllipsis = (text, max = 40) => {
  if (text.length > max) {
    return text.slice(0, max) + '...';
  } else {
    return text;
  }
};
